/**
 * Refusable consent helpers — parent must choose consent OR explicit decline (recorded).
 */

export function requiredConsentAckSatisfied(fields, ackKey) {
  return !!fields?.[ackKey];
}

export function pushRequiredConsentAck(errors, fieldErrorMap, fields, ackKey, label) {
  if (!fields?.[ackKey]) {
    const msg = `${label} is required for admission`;
    errors.push({ id: `packet-field-${ackKey}`, fieldKey: ackKey, message: msg });
    fieldErrorMap[ackKey] = msg;
  }
}

export function consentAckDeclineSatisfied(fields, ackKey, declineKey) {
  const ack = !!fields?.[ackKey];
  const decline = !!fields?.[declineKey];
  if (ack && decline) return false;
  return ack || decline;
}

/** HASC-wide PHI Authorization form slots (one per site). */
export const PHI_AUTHORIZATION_FORM_IDS = new Set(['form_20', 'fa_18', 'wm_17', 'bs_17']);

export function isPhiAuthorizationForm(formId) {
  return PHI_AUTHORIZATION_FORM_IDS.has(formId);
}

export function pushConsentAckDecline(errors, fieldErrorMap, fields, ackKey, declineKey, label) {
  const ack = !!fields?.[ackKey];
  const decline = !!fields?.[declineKey];
  if (ack && decline) {
    const msg = `Choose consent or decline for ${label} — not both`;
    errors.push({ id: `packet-field-${declineKey}`, fieldKey: declineKey, message: msg });
    fieldErrorMap[declineKey] = msg;
    return;
  }
  if (!ack && !decline) {
    const msg = `Please consent or decline: ${label}`;
    errors.push({ id: `packet-field-${ackKey}`, fieldKey: ackKey, message: msg });
    fieldErrorMap[ackKey] = msg;
  }
}

/** fa_09: at least one service OR explicit decline-all. */
export function fa09RemoteLearningSatisfied(fields) {
  if (fields?.remote_learning_decline) {
    const anyService = [
      'remote_classroom',
      'remote_speech',
      'remote_ot',
      'remote_pt',
      'remote_counseling',
    ].some((k) => !!fields[k]);
    return !anyService;
  }
  return [
    'remote_classroom',
    'remote_speech',
    'remote_ot',
    'remote_pt',
    'remote_counseling',
  ].some((k) => !!fields[k]);
}

/** Yes/No radio — value must be 'yes' or 'no' (legacy true/false accepted). */
export function yesNoAnswered(value) {
  return value === 'yes' || value === 'no' || value === true || value === false;
}

export function pushRequiredYesNo(errors, fieldErrorMap, fields, key, label) {
  if (!yesNoAnswered(fields?.[key])) {
    const msg = `Please select Yes or No: ${label}`;
    errors.push({ id: `packet-field-${key}`, fieldKey: key, message: msg });
    fieldErrorMap[key] = msg;
  }
}
